export const TemplateWarningModal: string = 'TemplateWarningModal';
